<form [formGroup]="userForm" (ngSubmit)="save()">
    <div class="card form-grid form-grid--2">
        <div class="form-field">
            <label for="firstname" class="form-field__label form-field__label--required">
                {{ 'components.settingsForm.userSection.firstname.label' | translate }}
            </label>
            <input
                id="firstname"
                pInputText
                type="text"
                formControlName="firstname"
                [placeholder]="'components.settingsForm.userSection.firstname.placeholder' | translate" />
            @if (userForm.controls.firstname.errors?.required && userForm.controls.firstname.touched) {
                <small class="p-error">{{ 'common.forms.validationMessages.required' | translate }}</small>
            }
        </div>
        <div class="form-field">
            <label for="lastname" class="form-field__label form-field__label--required">
                {{ 'components.settingsForm.userSection.lastname.label' | translate }}
            </label>
            <input
                id="lastname"
                pInputText
                type="text"
                formControlName="lastname"
                [placeholder]="'components.settingsForm.userSection.lastname.placeholder' | translate" />
            @if (userForm.controls.lastname.errors?.required && userForm.controls.lastname.touched) {
                <small class="p-error">{{ 'common.forms.validationMessages.required' | translate }}</small>
            }
        </div>
        <div class="form-field">
            <label for="email" class="form-field__label form-field__label--required">
                {{ 'components.settingsForm.userSection.email.label' | translate }}
            </label>
            <input
                id="email"
                pInputText
                type="text"
                formControlName="email"
                [placeholder]="'components.settingsForm.userSection.email.placeholder' | translate" />
            @if (userForm.controls.email.invalid && userForm.controls.email.touched) {
                @if (userForm.controls.email.errors?.required) {
                    <small class="p-error">{{ 'common.forms.validationMessages.required' | translate }}</small>
                } @else if (userForm.controls.email.errors?.invalidEmail) {
                    <small class="p-error">{{
                        'components.settingsForm.userSection.email.validation.invalid' | translate
                    }}</small>
                }
            }
        </div>
        <div class="form-field">
            <label for="phone" class="form-field__label">
                {{ 'components.settingsForm.userSection.phoneNumber.label' | translate }}
            </label>
            <input
                id="phone"
                pInputText
                type="text"
                formControlName="phone_number"
                [placeholder]="'components.settingsForm.userSection.phoneNumber.placeholder' | translate" />
            @if (userForm.controls.phone_number.errors?.invalidPn && userForm.controls.phone_number.touched) {
                <small class="p-error">{{
                    'components.settingsForm.userSection.phoneNumber.validation.invalid' | translate
                }}</small>
            }
        </div>
        <div class="form-field">
            <label for="roleId" class="form-field__label">
                {{ 'settings.users.form.role' | translate }}
                <span
                    class="material-symbols-outlined icon-sm align-middle cursor-help"
                    [pTooltip]="'settings.users.form.infotips.role' | translate"
                    [escape]="false"
                    >info</span
                >
            </label>
            <p-select
                inputId="roleId"
                [options]="roleOptions"
                formControlName="roleId"
                optionValue="id"
                optionLabel="labelKey"
                [placeholder]="'settings.users.form.role' | translate">
                <ng-template let-opt pTemplate="item">{{ opt.labelKey | translate }}</ng-template>
                <ng-template pTemplate="selectedItem">{{ selectedRoleLabelKey | translate }}</ng-template>
            </p-select>
            @if (isLastMainUser) {
                <small class="form-field__help">{{ 'settings.users.form.lastMainUserRole' | translate }}</small>
            }
        </div>
        @if (!isMainUserSelected) {
            <div class="form-field form-field--wide">
                <label for="entitiesInput" class="form-field__label">
                    {{ 'settings.users.form.entities' | translate }}
                    <span
                        class="material-symbols-outlined icon-sm align-middle cursor-help"
                        [pTooltip]="'settings.users.form.infotips.selectEntities' | translate"
                        >info</span
                    >
                </label>
                <p-multiSelect
                    inputId="entitiesInput"
                    [options]="entitiesOptions"
                    formControlName="entities"
                    optionLabel="name"
                    [placeholder]="'settings.users.form.selectEntities' | translate"
                    display="chip"
                    [filterPlaceHolder]="'common.search' | translate">
                    <ng-template pTemplate="selectedItems" let-selectedItems>
                        @if (selectedItems?.length > 0) {
                            <div class="chip-list">
                                @for (item of selectedItems; track item) {
                                    <p-chip [label]="item.name" />
                                }
                            </div>
                        }
                    </ng-template>
                </p-multiSelect>
            </div>
        }
    </div>
    <div class="form-actions">
        @if (canRemoveUser) {
            <p-button
                class="form-actions__start"
                severity="danger"
                [text]="true"
                icon="ms ms-delete"
                [label]="'components.settingsForm.button.remove' | translate"
                (onClick)="onDelete()" />
        }
        <p-button severity="secondary" [label]="'common.cancel_button' | translate" (onClick)="close()" />
        <p-button type="submit" [label]="'common.confirm_button' | translate" [loading]="saving" />
    </div>
</form>
<p-confirmDialog />
